import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckboxSetting from '../settings/CheckboxSetting';
import { Form, Row } from 'react-bootstrap';
import { AllowedVideoPlayers, VideoFieldModel } from '../../../../../../models/form/fields/video';
import SelectSetting from '../settings/SelectSetting';
import ColorSetting from '../settings/ColorSetting';
import { updateSelectedField, selectedFieldSelector } from '../../../../../../slices/formadmin';
import CultureTextSetting from '../settings/CultureTextSetting';
import { RootState } from '../../../../../../store';

const VideoProperties: FC = () => {
  const field = useSelector(selectedFieldSelector) as VideoFieldModel;
  const selectedLanguage = useSelector((state: RootState) => state.formAdmin.selectedLanguage) as string;
  const dispatch = useDispatch();

  return (
    <Form>
      <Row className="align-items-center">
        <CultureTextSetting
          id={`field.${field.id}.text`}
          culture={selectedLanguage}
          value={field.text}
          label="adminProperties.fields.common.text"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                text: val,
              }),
            )
          }
        />
        <ColorSetting
          value={field.textColor}
          label="adminProperties.fields.common.textColor"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                textColor: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'hiddenText'}
          checked={field.hiddenText}
          label="adminProperties.fields.common.hiddenText"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                hiddenText: val,
              }),
            )
          }
        />
      </Row>
      <Row>
        <CheckboxSetting
          id={field.id + 'visible'}
          checked={field.visible}
          label="adminProperties.fields.common.visible"
          size={6}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                visible: val,
              }),
            )
          }
        />
      </Row>
      <Row>
        <SelectSetting
          noEmptyValue={true}
          options={[{ text: 'Youtube', value: 'youtube' }]}
          label="adminProperties.fields.video.videoPlayer"
          size={6}
          value={field.videoPlayer}
          onChange={(val) => {
            dispatch(
              updateSelectedField({
                ...field,
                videoPlayer: val as AllowedVideoPlayers,
                defaultValue: '',
              }),
            );
          }}
        />
        {field.videoPlayer === 'youtube' && (
          <CultureTextSetting
            id={`field.${field.id}.defaultValue`}
            culture={selectedLanguage}
            value={field.defaultValue}
            label="adminProperties.fields.video.videoLink"
            size={12}
            onChange={(val) =>
              dispatch(
                updateSelectedField({
                  ...field,
                  defaultValue: val,
                }),
              )
            }
          />
        )}
      </Row>
    </Form>
  );
};

export default VideoProperties;
